export var kpiGrid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
  gap: '1.2em'
};
export var kpiCard = function kpiCard(accentColor) {
  return function (theme) {
    return {
      padding: '1.4em 1.6em',
      backgroundColor: theme.white,
      borderLeft: "4px solid ".concat(theme[accentColor] || accentColor),
      boxShadow: theme.boxShadowLight,
      '& .kpi-label': {
        fontSize: '1.15rem',
        fontWeight: 600,
        color: theme.gray500,
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        marginBottom: '0.6em'
      },
      '& .kpi-value': {
        fontSize: '2.2rem',
        fontWeight: 700,
        color: theme.gray800,
        lineHeight: 1.2
      },
      '& .kpi-sub': {
        fontSize: '1.2rem',
        color: theme.gray400,
        marginTop: '0.3em'
      },
      '& .kpi-badge': {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.4em',
        fontSize: '1.15rem',
        fontWeight: 600,
        marginTop: '0.6em',
        padding: '0.2em 0.6em',
        backgroundColor: "".concat(theme[accentColor] || accentColor, "15"),
        color: theme[accentColor] || accentColor
      }
    };
  };
};